const stateService = require('../../services/state/stateService')

const state = {
  states: []
}

const mutations = {
  setStates (state, states) {
    state.states = states
  }
}

const actions = {

  async fetchStates({ commit }, params) {
    try {
      const { data } = await stateService.fetchStates(params)
      commit('setStates', data)
    } catch {}
  },
}

const getters = {
  states: (state) => state.states,
}

export default {
  state,
  mutations,
  actions,
  getters,
}
